import React from "react";

// Shared layout for the owner and charity Help pages: a "jump to" list at
// the top, then one card per topic. Each topic is { id, title, where, body[] }.
// A body item that is a list (array) shows as bullet points.
export default function HelpPage({ intro, sections }) {
  const card = { background: "#17131F", padding: "20px", borderRadius: "14px", scrollMarginTop: "20px" };
  return (
    <div style={{ color: "#fff", maxWidth: "820px", display: "flex", flexDirection: "column", gap: "16px", paddingBottom: "40px" }}>
      <div>
        <h1 style={{ margin: 0, fontFamily: "'Bebas Neue', Inter, sans-serif", fontWeight: 400, fontSize: "44px", letterSpacing: "0.5px" }}>
          Help
        </h1>
        <p style={{ margin: "6px 0 0", fontSize: "17px", color: "#ACA8BF", lineHeight: 1.5 }}>{intro}</p>
      </div>

      <nav aria-label="Help topics" style={{ ...card, display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {sections.map((s) => (
          <a
            key={s.id}
            href={`#${s.id}`}
            style={{ padding: "8px 12px", borderRadius: "10px", background: "#2A2238", color: "#fff", textDecoration: "none", fontSize: "15px", fontWeight: 600 }}
          >
            {s.title}
          </a>
        ))}
      </nav>

      {sections.map((s) => (
        <section key={s.id} id={s.id} style={card}>
          <h2 style={{ margin: "0 0 4px", fontSize: "20px" }}>{s.title}</h2>
          {s.where && <p style={{ margin: "0 0 12px", fontSize: "14px", color: "#B9A6FF", fontWeight: 600 }}>Where: {s.where}</p>}
          {s.body.map((p, i) =>
            Array.isArray(p) ? (
              <ul key={i} style={{ margin: i === s.body.length - 1 ? 0 : "0 0 12px", paddingLeft: "22px", lineHeight: 1.6, fontSize: "16px", color: "#D6D2E4" }}>
                {p.map((li, j) => (
                  <li key={j}>{li}</li>
                ))}
              </ul>
            ) : (
              <p key={i} style={{ margin: i === s.body.length - 1 ? 0 : "0 0 12px", lineHeight: 1.6, fontSize: "16px", color: "#D6D2E4" }}>
                {p}
              </p>
            )
          )}
        </section>
      ))}

      <section style={{ ...card, border: "1px dashed #5A5070", background: "transparent" }}>
        <h2 style={{ margin: "0 0 6px", fontSize: "18px" }}>Still stuck?</h2>
        <p style={{ margin: 0, lineHeight: 1.6, color: "#D6D2E4" }}>
          Email <a href="mailto:hello@barfunfinder.com" style={{ color: "#FF6FA3" }}>hello@barfunfinder.com</a> and we'll help you directly.
        </p>
      </section>
    </div>
  );
}
